import { titleRatio } from "../../../../lib/titleProgress";
const MONTHS = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];

const parse = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value ?? "");
  return match ? { month: Number(match[2]), day: Number(match[3]) } : null;
};

/** Dönemin aralığı: "22 · 28 Eylül"; ay değişirse "28 Eylül · 4 Ekim"; tek günse "24 Eylül". */
export function rangeLabel(startDate, endDate) {
  const start = parse(startDate);
  const end = parse(endDate);
  if (!start || !end) return "";
  const endText = `${end.day} ${MONTHS[end.month - 1]}`;
  if (startDate === endDate) return endText;
  return start.month === end.month
    ? `${start.day} · ${endText}`
    : `${start.day} ${MONTHS[start.month - 1]} · ${endText}`;
}

/** "2026-09-21" → "21 Eylül" */
export function shortDate(value) {
  const date = parse(value);
  return date ? `${date.day} ${MONTHS[date.month - 1]}` : "";
}

/** Kilitli ünvanın ilerlemesi (0..1); eşiği geçince 1. */
export function titleProgress(title) {
  return titleRatio(title);
}

/** Kıyas farkı: "+12", "-5", "0"; önceki yoksa null. */
export function formatDelta(delta) {
  if (delta === null || delta === undefined) return null;
  return delta > 0 ? `+${delta}` : String(delta);
}
